import '../notification-banner';
import '../digital-scotland/back-to-top';
import '../digital-scotland/data-picker';
import '../digital-scotland/mobile-tables';
import { initAll } from 'govuk-frontend';
import $ from 'jquery';

document.body.className += ' js-enabled' + ('noModule' in HTMLScriptElement.prototype ? ' govuk-frontend-supported' : '');
initAll();

$(document).ready(function(){
    if($(".govuk-accordion__section--expanded")) {
        // Note this is necessary as session state is managed internally by the GOV.UK library for the accordion component
        $(".govuk-accordion__open-all").click();
        $(".govuk-accordion__open-all").click();
    }
});
